export default __webpack_public_path__ + "static/media/group.e55a74c5.svg";